import Route from '@ember/routing/route';

export default class ResetPasswordConfirmationRoute extends Route {}
